import { useState, useEffect } from 'react';
import { Builder, builder, BuilderComponent } from '@builder.io/react';

import useCache from '../../hooks/useCache';

import './components/usp/Usp';
import './components/heading/Heading';
import './components/inspiration/InspirationBanner';
import './components/layout/Dummy';
import './components/layout/FullRowGrid';
import './components/layout/TwoColumnGrid';
import './components/layout/ThreeColumnGrid';
import './components/layout/SixColumnGrid';
import './components/layout/RowGridWithImage';
import './components/layout/FourEightGrid';
import './components/message/infomessage/InfoMessage';
import './components/banner/Banner';
import './components/categoryelement/CategoryElement'
import './components/recentlyviewed/RecentlyViewed';
import './components/brands/Brands';
import './components/subcategories/SubCategories';
import './components/button/Button';
import './components/products/Products';
import './components/algoliaproducts/AlgoliaProducts';
import './components/contact/Contact';
import './components/faq/short/FaqShortList';
import './components/faq/menu/FaqMenu';
import './components/faq/qa/Qa';
import './components/contactform/Contactform';
import './components/returnform/Returnform';
import './components/breadcrumb/BreadcrumbBuilder';
import './components/quoteform/Quoteform';
import './components/trendingitems/TrendingItems';
import './components/newsletter/NewsletterSubscribed';
import './components/newsletter/NewsletterUnsubscribed';
import './components/accountpageheading/AccountPageHeading';
import './components/accountoverviewheading/AccountOverviewHeading';
import './components/accounttile/AccountTile';
import './components/accounttilewrapper/AccountTileWrapper';
import './components/bbwvideo/BBWVideo';
import './components/bbwchannel/BBWChannel';
import './components/blog/Blog';

builder.init('196c263ab2894a338e807c5bee37e4df');


const BuilderSection = ({ model = null, url = null, renderLoading = null, renderNotFound = null }) => {
    const cache = useCache();
    const [loading, setLoading] = useState(false);

    const isBuilder = !Builder.isEditing && !Builder.isPreviewing;

    const cacheKey = model + (url !== null ? ':' + url : '');

    const builderProps = {};

    if (!isBuilder) {
        builderProps.content = cache.get(cacheKey);
    }

    if (url !== null) {
        builderProps.url = url;
    }

    useEffect(() => {
        const fetchContent = async () => {
            try {
                setLoading(true);
                const content = await builder.get(model, { url: url }).promise();
                if (isBuilder) {
                    cache.set(cacheKey, content);
                }
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        }

        fetchContent();

    }, [model, cacheKey]);

    if (loading && builderProps?.content !== undefined) {
        return renderLoading && renderLoading();
    }

    if (!isBuilder && builderProps?.content === undefined) {
        return renderNotFound && renderNotFound();
    }

    return (
        <BuilderComponent model={model} {...builderProps} />
    );
}

export default BuilderSection;